module.exports = __webpack_public_path__ + "img/digital-manager-guru.03555a60.svg";